import documentRequestCandidateService from '../../../store/document-request-candidate/service';

export const useGetCandidateDocumentList = () => {
  const { data: candidateData, isLoading } =
    documentRequestCandidateService.endpoints.getCandidateDocumentList.useQuery(
      '?filter[status][]=NEEDS_REVIEW&filter[status][]=REJECTED&filter[status][]=REQUESTED&filter[status][]=UPLOADED&filter[status][]=PARTIALLY_UPLOADED',
      {
        refetchOnMountOrArgChange: true,
      }
    );

  return {
    candidateData,
    isLoading,
  };
};
